import { Close20, Time16 } from "@carbon/icons-react";
import Add16 from "@carbon/icons-react/es/add/16";
import Close16 from "@carbon/icons-react/es/close/16";
import Send16 from "@carbon/icons-react/es/send/16";
import TrashCan16 from "@carbon/icons-react/es/trash-can/16";
import { Col, Row } from "antd";
import {
  ActionBarComponent,
  Button,
  InputText,
  Modal,
  StandardTable,
} from "react3l-ui-library";
import nameof from "ts-nameof.macro";
import { useMenuReportDetailHook } from "./MenuReportDetailHook";
import { authorizationService } from "services/common-services/authorization-service";
import { MENU_REPORT_ROUTE } from "config/route-consts";
import { API_MENU_REPORT_PREFIX } from "config/api-consts";
import { masterService } from "services/page-services/master-service";

function MenuReportDetail() {
  const { validAction } = authorizationService.useAuthorizedAction(
    MENU_REPORT_ROUTE.split("/")[MENU_REPORT_ROUTE.split("/").length - 1],
    API_MENU_REPORT_PREFIX
  );

  const { handleGoHistory } = masterService.useMasterAction(MENU_REPORT_ROUTE);

  const {
    listFileTemplate,
    isDetail,
    fileTemplateColumns,
    model,
    rowSelection,
    selectedRowKeys,
    canBulkAction,
    loadingType,
    selectedRowKeysFileTemplateInput,
    rowSelectionFileTemplateInput,
    canBulkActionFileTemplateInput,
    fileTemplateInputColumns,
    fileTemplateInputsInternal,
    visible,
    translate,
    handleSaveModel,
    handleGoMaster,
    handleAddRow,
    setSelectedRowKeys,
    handleBulkDelete,
    handleSaveModal,
    handleCloseModal,
    handleAddFileTemplateInput,
    setSelectedRowKeysFileTemplateInput,
    handleBulkDeleteFileTemplateInput,
  } = useMenuReportDetailHook();

  return (
    <>
      <div className="page-content page-content-dxg" id="page-content-dxg-id">
        <div className="info-component ml-4 mb-3">
          <span>{translate("fileTemplates.master.header")}</span>
          <span> &gt; </span>
          <span className="info-primary">
            {translate("fileTemplates.master.subHeader")}
          </span>
        </div>

        <div className="page page-detail p-t--lg p-l--md p-r--sm p-b--lg">
          <div className="mb-3 d-flex justify-content-between border-bottom">
            <h5 className="font-bold ml-3">
              {!isDetail
                ? translate("general.actions.create")
                : translate("general.detail.title")}
            </h5>
            <div className="pb-2">
              <Button
                type="secondary"
                className="btn--lg btn-red"
                icon={<Close16 />}
                onClick={handleGoMaster}
              >
                {translate("general.actions.close")}
              </Button>
              <Button
                type="secondary"
                className="btn--lg btn-orange-export ml-3"
                icon={<Time16 />}
                onClick={handleGoHistory(model?.id)}
              >
                {translate("general.actions.viewHistory")}
              </Button>
              {((!isDetail && validAction("create")) ||
                (isDetail && validAction("update"))) && (
                <Button
                  type="primary"
                  className="btn--lg btn-blue ml-2"
                  icon={<Send16 />}
                  onClick={handleSaveModel}
                >
                  {translate("general.actions.save")}
                </Button>
              )}
            </div>
          </div>

          <Row>
            <Col lg={6} className="m-b--xxs p-r--sm">
              <InputText
                label={translate("menuReports.site")}
                isRequired={true}
                type={0}
                value={model.site?.name}
                placeHolder={translate("menuReports.placeholder.site")}
                disabled={true}
              />
            </Col>
            <Col lg={6} className="m-b--xxs p-r--sm">
              <InputText
                label={translate("menuReports.menu")}
                isRequired={true}
                type={0}
                value={model.menu?.name}
                placeHolder={translate("menuReports.placeholder.menu")}
                disabled={true}
              />
            </Col>
            <Col lg={6} className="m-b--xxs p-r--sm">
              <InputText
                label={translate("menuReports.name")}
                isRequired={true}
                type={0}
                value={model.name}
                placeHolder={translate("menuReports.placeholder.name")}
                disabled={true}
              />
            </Col>
          </Row>
          <Row className="p-t--xxs">
            <Col lg={24}>
              <div className="d-flex justify-content-end">
                <Button
                  type="secondary"
                  className="btn--lg btn-orange-export"
                  icon={<Add16 />}
                  onClick={handleAddRow}
                >
                  {translate("general.actions.create")}
                </Button>
              </div>
              <div className="condition-table">
                <ActionBarComponent
                  selectedRowKeys={selectedRowKeys}
                  setSelectedRowKeys={setSelectedRowKeys}
                >
                  <Button
                    icon={<TrashCan16 />}
                    type="ghost-primary"
                    className="btn--lg"
                    disabled={!canBulkAction}
                    onClick={handleBulkDelete}
                  >
                    {translate("general.actions.delete")}
                  </Button>
                </ActionBarComponent>
                <StandardTable
                  rowKey={nameof("key")}
                  rowSelection={rowSelection}
                  columns={fileTemplateColumns}
                  dataSource={listFileTemplate}
                  tableSize={"lg"}
                  scroll={{ y: 1500 }}
                />
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <Modal
        size={1400 as any}
        visibleFooter={true}
        visible={visible}
        title={translate("fileTemplates.fileTemplateInputs.title")}
        handleSave={handleSaveModal}
        handleCancel={handleCloseModal}
        titleButtonCancel={translate("general.actions.close")}
        titleButtonApply={translate("general.actions.save")}
        loadingType={loadingType}
        closable={false}
        wrapClassName={"dxg-modal-wrap"}
      >
        <div className="modal-content">
          <div className="m-t--sm">
            <div className="d-flex justify-content-end">
              <Button
                type="secondary"
                className="btn--lg btn-orange-export pb-2"
                icon={<Add16 />}
                onClick={handleAddFileTemplateInput}
              >
                {translate("general.actions.create")}
              </Button>
            </div>
            <div className="w-100">
              <ActionBarComponent
                selectedRowKeys={selectedRowKeysFileTemplateInput}
                setSelectedRowKeys={setSelectedRowKeysFileTemplateInput}
              >
                <Button
                  icon={<TrashCan16 />}
                  type="ghost-primary"
                  className="btn--lg"
                  disabled={!canBulkActionFileTemplateInput}
                  onClick={handleBulkDeleteFileTemplateInput}
                >
                  {translate("general.actions.delete")}
                </Button>
              </ActionBarComponent>
              <StandardTable
                rowKey={nameof("key")}
                rowSelection={rowSelectionFileTemplateInput}
                columns={fileTemplateInputColumns}
                dataSource={fileTemplateInputsInternal}
                tableSize={"lg"}
                scroll={{ y: 500 }}
                isDragable={true}
                className="table-dxg-file-example"
              />
            </div>
          </div>
        </div>

        <span className={"close-modal"} onClick={handleCloseModal}>
          <Close20 />
        </span>
      </Modal>
    </>
  );
}
export default MenuReportDetail;
